/* ============================================================
   PLUSHIE PATCH — 360° spin viewer
   Drag (mouse + touch) to rotate through frames. Amazon-style.
   Frames come from the product metafield custom.spin_frames.
   ============================================================ */
(function () {
  "use strict";

  var S = { ready: false, autospun: false, frames: [], idx: 0, sensitivity: 8, autospin: true,
            img: null, stage: null, hint: null };

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var spin = document.getElementById('spin360');
    if (!spin) return; // no spin frames for this product

    try { S.frames = JSON.parse(spin.getAttribute('data-frames') || '[]'); } catch (e) { S.frames = []; }
    S.frames = S.frames.filter(Boolean);
    if (S.frames.length < 2) return;

    S.img = document.getElementById('spinFrame');
    S.stage = document.getElementById('spinStage');
    S.hint = document.getElementById('spinHint');
    var loading = document.getElementById('spinLoading');
    S.sensitivity = parseFloat(spin.getAttribute('data-sensitivity')) || 8;
    S.autospin = (spin.getAttribute('data-autospin') || '') !== 'false';

    // Preload every frame, then enable interaction
    var loaded = 0;
    S.frames.forEach(function (src) {
      var im = new Image();
      im.onload = im.onerror = function () {
        loaded++;
        if (loaded === S.frames.length) {
          S.ready = true;
          if (loading) loading.style.display = 'none';
        }
      };
      im.src = src;
    });

    bindDrag();
  }

  function show(i) {
    var n = S.frames.length;
    S.idx = ((i % n) + n) % n;
    if (S.img) S.img.src = S.frames[S.idx];
  }

  function autoSpinOnce() {
    if (!S.ready || S.autospun || !S.autospin) return;
    S.autospun = true;
    var f = 0, n = S.frames.length;
    var t = setInterval(function () {
      show(f); f++;
      if (f >= n) clearInterval(t);
    }, 45);
  }

  function bindDrag() {
    var dragging = false, startX = 0, startIdx = 0, moved = false;

    function down(x) { if (!S.ready) return; dragging = true; startX = x; startIdx = S.idx; moved = false; if (S.stage) S.stage.classList.add('grabbing'); }
    function move(x) {
      if (!dragging || !S.ready) return;
      var d = x - startX;
      if (Math.abs(d) > 4 && !moved) { moved = true; if (S.hint) S.hint.style.opacity = '0'; }
      var steps = Math.round(d / S.sensitivity);
      show(startIdx - steps);
    }
    function up() { dragging = false; if (S.stage) S.stage.classList.remove('grabbing'); }

    if (!S.stage) return;
    S.stage.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function (e) { move(e.clientX); });
    window.addEventListener('mouseup', up);
    S.stage.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    S.stage.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      move(e.touches[0].clientX);
      if (moved) e.preventDefault(); // lock horizontal spin without scrolling the page
    }, { passive: false });
    S.stage.addEventListener('touchend', up);
    S.stage.addEventListener('touchcancel', up);
  }

  // Photos / 360° tab switch (global so the inline onclick can call it)
  window.ppMedia = function (view, btn) {
    var main = document.getElementById('mainImgWrap');
    var thumbs = document.getElementById('thumbs');
    var spin = document.getElementById('spin360');
    var tabs = document.querySelectorAll('#mediaTabs .mt');
    tabs.forEach(function (b) { b.classList.remove('on'); });
    if (btn) btn.classList.add('on');

    if (view === 'spin') {
      if (main) main.style.display = 'none';
      if (thumbs) thumbs.style.display = 'none';
      if (spin) spin.hidden = false;
      autoSpinOnce();
    } else {
      if (main) main.style.display = '';
      if (thumbs) thumbs.style.display = '';
      if (spin) spin.hidden = true;
    }
  };
})();
